import { Image } from "react-native";
import { useSelector } from "react-redux";

import { getBonusBannerImageByLanguage } from "../../../../assets/buttonsByLanguage";
import { RootState } from "../../../../store";
import Centered from "../../../../shared/Centered";

interface IProps {
  isSmall: boolean;
}

function BGLogo({ isSmall }: IProps) {
  const langCode = useSelector((s: RootState) => s.i18n?.langCode ?? "en");

  return (
    <Centered
      style={{
        width: "100%",
        position: "absolute",
        left: 0,
        right: 0,
        top: isSmall ? -20 : -18,
        height: 1,
      }}
    >
      <Image
        source={getBonusBannerImageByLanguage(langCode)}
        resizeMode="contain"
        style={{
          width: isSmall ? "100%" : "70%",
          aspectRatio: 3.33,
          transform: [{ scale: isSmall ? 1 : 0.8 }],
        }}
      />
    </Centered>
  );
}

export default BGLogo;